<template>
    <!-- coloca tudo dentro de um div pra classe .d-block não bugar o v-show do vue -->
    <div>
        <a
            class="catalog-filter-group-option d-block cursor-pointer text-no-decoration"
            :href="url"
            @click="fetch">
            <div
                :class="{'d-flex flex-align-center': hex}">
                <div
                    v-if="hex">
                    <div
                        v-if="isSelected"
                        class="pos-relative rounded-full px-1 py-1 mr border border-solid border-2"
                        :style="`width: 1rem; height: 1rem; border-color: #${hex}`">
                        <div class="pos-absolute pos-center rounded-full"
                             :style="`width: .5rem; height: .5rem; background-color: #${hex}`"/>
                    </div>
                    <div
                        v-else
                        class="pos-relative rounded-full px-1 py-1 mr"
                        :style="`width: 1rem; height: 1rem; background-color: #${hex}`"/>
                </div>
                <input
                    v-else
                    class="cr-radio"
                    type="radio"
                    :id="radioId"
                    :name="radioGroup"
                    :value="value"
                    :checked="isSelected"/>
                <label
                    :for="radioId"
                    class="text-nowrap d-flex flex-align-center flex-item-grow cursor-pointer">
                    <span class="mr">{{ label }}</span>
                    <div
                        v-if="count"
                        class="ml-auto badge-default-1">
                        {{ count }}
                    </div>
                </label>
            </div>
        </a>
    </div>
</template>

<script>
    import Radio from '@bit/chicorei.chicomponents.input.radio';
    import {catalogStore} from "../../common/store/catalog-store";

    export default {
        name: "CatalogFilterGroupOption",

        components: {Radio},

        inject: {
            filterGroup: {
                default() {
                    return {}
                }
            }
        },

        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: Number | String,
                required: true
            },
            urlParam: {
                type: String,
                required: true
            },
            link: {
                type: Number | String,
            },
            count: Number,
            handleFetch: {
                type: Boolean,
                default: true
            },
            hex: String,
        },

        mounted() {
            this.filterGroup.registerOption(this);
        },

        computed: {
            radioGroup() {
                return this.filterGroup.radioName().toLowerCase();
            },

            radioId() {
                return this.urlParam + '-' + this.value;
            },

            selectedValueInGroup() {
                return this.filterGroup.value();
            },

            isSelected() {
                return (this.selectedValueInGroup || null) === (this.value || null);
            },

            url() {
                return catalogStore.buildUrl(
                    this.urlParam,
                    this.value,
                    this.link,
                    !this.value || this.isSelected
                );
            }
        },

        methods: {
            fetch(event) {
                window.dataLayer.push({
                    event: 'clickOnCatalogFilter'
                });

                // Carregamento dinâmico se a API pushState estiver disponível
                if (typeof (history.pushState) !== 'function') return true;

                event.preventDefault();

                if (this.handleFetch) {
                    catalogStore.fetch(this.axios, this.url);
                } else {
                    this.$emit('fetch', this.url);
                }
            }
        }
    }
</script>